import type { TouchableOpacityProps } from 'react-native'
import * as Comp from './tooltip-trigger.styles'

interface TTooltipTriggerProps extends TouchableOpacityProps {}

export function TooltipTrigger({ children, ...rest }: TTooltipTriggerProps) {
  return <Comp.Trigger {...rest}>{children}</Comp.Trigger>
}
